import { getError } from 'atoms/create-resource-atom';
import { TextArea, Layer } from '@carbon/react';
import { FormRow } from 'components/forms';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { useMemo } from 'react';
import { formAtoms } from '../atoms';

const Note = () => {
  const noteAtom = useMemo(
    () => atom((get) => get(get(formAtoms).formAtom).notes),
    []
  );
  const setField = useSetAtom(useAtomValue(formAtoms).formAtom);
  const note = useAtomValue(noteAtom);

  return (
    <FormRow>
      <Layer>
        <TextArea
          labelText="Notes"
          placeholder="Text Field"
          id={`notes`}
          value={note.value || ''}
          onChange={({ target: { value } }) =>
            setField({ field: 'notes', value })
          }
          invalid={!!getError(note)}
          invalidText={getError(note)}
        />
      </Layer>
    </FormRow>
  );
};

export { Note };
